<template>
  <div v-if="item.children" class="menu-item">
    <template v-if="item.children.length == 0">
      <el-menu-item :index="item.pagePath">
        <i
          v-show="item.iconResourceId.length > 0"
          :class="item.iconResourceId"
        ></i>
        <span slot="title">{{ item.name }}</span>
      </el-menu-item>
    </template>
    <el-submenu v-else :index="item.id">
      <template slot="title">
        <i
          v-show="item.iconResourceId.length > 0"
          :class="item.iconResourceId"
        ></i>
        <span slot="title">{{ item.name }}</span>
      </template>

      <template v-for="child in item.children">
        <sidebar-item
          v-if="child.children && child.children.length > 0"
          :item="child"
          :key="child.pagePath"
        />
        <el-menu-item v-else :key="child.pagePath" :index="child.pagePath">
          <i
            v-show="child.iconResourceId.length > 0"
            :class="child.iconResourceId"
          ></i>
          <span slot="title">{{ child.name }}</span>
        </el-menu-item>
      </template>
    </el-submenu>
  </div>
</template>

<script>
export default {
  name: "SidebarItem",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-item {
      width: 160px;
    flex: 0 0 160px;
}
</style>